/*
 *   File : confirm-notification-modal.js
 *   Author : https://evoqins.com
 *   Description : confirm-notification-modal component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { PrimaryButton } from "../Buttons";

/* ---------- Overlay (same as SuccessModal) ---------- */
const ModalOverlay = ({ onClose }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"
      style={{ zIndex: 1040 }}
      onClick={onClose}
    />
  );
};

/* ---------- Notification Modal ---------- */
export default function ConfirmNotificationModal({
  open = false,
  title,
  content,
  time,
  onCancel,
  onPress,
  loading,
}) {
  if (!open) return null;

  return createPortal(
    <>
      {/* Overlay */}
      <ModalOverlay onClose={onCancel} />

      <div
        className="position-fixed overflow-hidden top-50 start-50 translate-middle rounded-28 shadow bg-white bg-opacity-80"
        style={{
          zIndex: 1055,
          width: "600px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-24 d-flex flex-column" style={{ rowGap: "20px" }}>
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center w-100">
            <h5 className="fw-500 fs-18 mb-0 text-eerie-black">
              Send Notification
            </h5>

            <PrimaryButton
              icon="close"
              ClassName="bg-transparent p-0"
              onPress={onCancel}
            />
          </div>

          {/* Notification Preview Box */}
          <div className="w-100 d-flex column-gap-3 bg-white bg-opacity-50 p-2 align-items-start rounded-8">
            <div className="d-flex column-gap-3 p-3 rounded-20 bg-white w-100">
              {/* Icon */}
              <div className="d-flex justify-content-center">
                <img
                  width={24}
                  src={require("../../Assets/Images/logo-icon.svg").default}
                  alt="funds app"
                />
              </div>

              {/* Text Content */}
              <div className="flex-grow-1 d-flex flex-column w-100 min-w-0">
                <div className="d-flex justify-content-between align-items-start w-100 gap-2">
                  <h5
                    className="fw-600 fs-14 text-eerie-black mb-1 text-truncate"
                    style={{
                      maxWidth: "100%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                    title={title}
                  >
                    {title}
                  </h5>

                  <p className="mb-0 fw-400 fs-10 text-cultured-gray flex-shrink-0">
                    {time || "3m ago"}
                  </p>
                </div>

                <p
                  style={{
                    maxWidth: "100%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                  className="fw-400 fs-14 text-davys-gray mb-0 lh-1 text-truncate"
                >
                  {content}
                </p>
              </div>
            </div>
          </div>

          {/* Footer Buttons */}
          <div className="row row-cols-2 pt-2">
            <div className="col pe-2">
              <PrimaryButton
                name="Cancel"
                ClassName="rounded-pill bg-transparent border-oxford-blue text-oxford-blue py-3 w-100 fs-16 fw-500"
                onPress={onCancel}
              />
            </div>

            <div className="col ps-2">
              <PrimaryButton
                name="Send"
                disable={loading}
                ClassName="rounded-pill bg-oxford-blue text-white py-3 w-100 fs-16 fw-500"
                onPress={onPress}
              />
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
}
